module.exports = __webpack_public_path__ + "media/images/okra-offers/recent-post-6e0d8579b66b1829d9e24f9531bab721.png";